import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useLanguage } from '@/lib/i18n';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Info } from 'lucide-react';

export default function Allergens() {
  const { t } = useLanguage();

  const allergenKeys = [
    'gluten', 'crustaceans', 'eggs', 'fish', 'peanuts',
    'soybeans', 'milk', 'nuts', 'celery', 'mustard',
    'sesame', 'sulphites', 'lupin', 'molluscs'
  ];

  return (
    <div className="min-h-screen bg-cream" data-testid="allergens-page">
      <Navbar />
      <div className="pt-28 pb-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
            <div>
              <h1 className="text-4xl font-heading font-bold text-garden-800">{t('allergens.title')}</h1>
              <p className="text-sm text-charcoal/70 mt-2">{t('allergens.subtitle')}</p>
            </div>
            <Link to="/carte">
              <Button variant="outline" className="border-garden-200 text-garden-850 hover:bg-garden-50 rounded-full text-sm">
                <ArrowLeft size={16} className="mr-2" /> Retour à la carte
              </Button>
            </Link>
          </div>

          <div className="bg-white rounded-3xl p-6 sm:p-8 border border-garden-800/5 shadow-sm space-y-6">
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {allergenKeys.map((key, index) => (
                <div 
                  key={key} 
                  className="p-4 bg-garden-50/30 border border-garden-850/5 rounded-2xl flex items-start gap-3 hover:bg-garden-50/60 transition-colors"
                  data-testid={`allergen-item-${key}`}
                >
                  <div className="w-8 h-8 rounded-full bg-garden-100 flex items-center justify-center text-garden-800 font-semibold text-sm shrink-0">
                    {index + 1}
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-garden-800 text-sm capitalize">{t(`allergens.names.${key}`)}</h3>
                    <p className="text-xs text-charcoal/70 mt-1 leading-relaxed">
                      {t(`allergens.list.${key}`)}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-amber-50/40 border border-amber-500/10 p-4 rounded-2xl flex items-start gap-3 mt-8">
              <Info className="text-amber-600 shrink-0 mt-0.5" size={18} />
              <p className="text-xs text-charcoal/80 leading-relaxed">
                {t('allergens.notice')}
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
